<template>
  <div>
    <div :key="`limpaKey${limpaKey}`" :class="['cenario-wrapper', 'no-print']">
      <!-- //HABILITAR PARA TESTES -->
      <!-- <div @click="teste()"> -->
      <!-- {{ dadosForm }} -->
      <!-- {{ getCenario }} -->
      <!-- </div> -->

      <CenarioLoading v-if="loading" />
      <ModalDuplicar
        :id="id"
        :ncmLabel="ncmLabel"
        :dadosForm="dadosForm"
        :nomeCenario="nomeCenario"
        :numeroCenarios="numeroCenarios"
        :numeroNomeCenario="numeroNomeCenario"
      />
      <CenarioCabecalho
        :id="id"
        :ncmLabel="ncmLabel"
        :listaNcm="listaNcm"
        :dadosForm="dadosForm"
        :nomeCenario="nomeCenario"
        :validaCampos="validaCampos"
        :calculaDados="calculaDados"
        :numeroCenarios="numeroCenarios"
        :exibeValidacao="exibeValidacao"
        :calculaDadosForm="calculaDadosForm"
        :mostraCamposCenario="mostraCamposCenario"
      />
      <CenarioCorpo
        v-show="mostraCamposCenario"
        :id="id"
        :filtros="filtros"
        :listaNcm="listaNcm"
        :dadosForm="dadosForm"
        :listaCnae="listaCnae"
        :travaBotoes="travaBotoes"
        :nomeCenario="nomeCenario"
        :calculaDados="calculaDados"
        :verificaCNPJ="verificaCNPJ"
        :validaCampos="validaCampos"
        :carregaSalvar="carregaSalvar"
        :numeroCenarios="numeroCenarios"
        :exibeValidacao="exibeValidacao"
        :elementoCriado="elementoCriado"
        :buscarResultado="buscarResultado"
        :resultadoExibido="resultadoExibido"
        :impedimentoSnRes="impedimentoSnRes"
        :impedimentoSnDes="impedimentoSnDes"
        :calculaDadosForm="calculaDadosForm"
        :imprimirResultado="handleImprimirResultado"
        :submitSalvarCenario="submitSalvarCenario"
        :carregandoAlgumaCnae="carregandoAlgumaCnae"
        :carregaCenarioLoading="carregaCenarioLoading"
        :openModalCnaeCompreende="openModalCnaeCompreende"
      />
    </div>
    <ImpressaoCenario
      class="cenario-impressao"
      :ncm="ncm"
      :filtros="filtros"
      :dadosForm="dadosForm"
      :nomeCenario="nomeCenario"
      :cnaeRemetenteLabel="cnaeRemetenteLabel"
      :cnaeDestinatarioLabel="cnaeDestinatarioLabel"
    />
  </div>
</template>

<script>
import ImpressaoCenario from "../ImpressaoCenario/ImpressaoCenario.vue";
import CenarioCabecalho from "./CenarioCabecalho.vue";
import CenarioCorpo from "./CenarioCorpo.vue";
import CenarioLoading from "./CenarioLoading.vue";
import ModalDuplicar from "@/components/ModalCenario/ModalDuplicar.vue";
import Api from "@/services/api.js";
import filtros from "@/store/modules/cenarioFiltros.js";
import stringFormatMixin from "@/mixins/stringFormatMixin";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "v-cenario",

  components: {
    CenarioCabecalho,
    CenarioCorpo,
    ImpressaoCenario,
    CenarioLoading,
    ModalDuplicar
  },

  mixins: [stringFormatMixin],

  inject: ["pushAlert", "setExibeResultado", "setExibeCarregando", "checaTodosFormularios"],

  props: {
    id: Number,
    cenarioId: Number,
    numeroNomeCenario: String | Number,
    cenarioCnpjRemetente: Array,
    cenarioCnpjDestinatario: Array,
    numeroCenarios: Number,
    verificaCNPJ: Function,
    openModalCnaeCompreende: Function,
    imprimirResultado: Function,
    modalImpressaoToggle: Boolean,
    mostraCamposCenario: Boolean,
    resultadoExibido: Boolean,
    loadingResultado: Boolean,
    chamaSalvar: Boolean,
    chamaLimpar: Boolean
  },

  provide() {
    return {
      existeLoading: this.existeLoading,
      setElementoCriado: this.setElementoCriado,
      setTrava: this.setTrava,
      abreModalLimpar: this.abreModalLimpar,
      abreModalRemover: this.abreModalRemover
    };
  },

  data() {
    return {
      filtros,
      idLogCenario: null,
      numeroSlide: null,
      carregandoAlgumaCnae: false,
      carregaSalvar: false,
      elementoCriado: false,
      loading: false,
      exibeValidacao: false,
      carregaCenarioLoading: false,
      impedimentoSnRes: false,
      impedimentoSnDes: false,
      travaBotoes: false,
      valida: "",
      ncmLabel: "",
      nomeCenario: "",
      cnaeRemetenteLabel: "",
      cnaeDestinatarioLabel: "",
      limpaKey: 0,
      listaNcm: [],
      ncm: {},
      cenarioModifica: {},
      listaCnae: {},
      dadosForm: {
        ncm: "",
        tipoOperacao: "",
        ex: "",
        cnpjRemetente: "",
        cnpjDestinatario: "",
        ufOrigem: "",
        ufDestino: "",
        paisOrigem: "",
        paisDestino: "",
        atividadeRemetente: "",
        tipoAtividadeRem: "",
        cnaeRemetente: "",
        cnaeDestinatario: "",
        sabeCNPJDestinatario: "0",
        atividadeDestino: "",
        tipoAtividade: "",
        origem: "",
        destinacao: "",
        zfm: "",
        regimeRemetente: "",
        regimeDestinatario: "",
        regra: 0,
        sn_rbt12: "R$ 0,00",
        sn_rba: "R$ 0,00",
        sn_rm: "R$ 0,00"
      }
    };
  },
  created() {
    // this.$bus.$on("console", () => console.log(this.dadosForm));
    if (this.id == 1) {
      this.fetchAlertas();
    }

    this.dadosForm.cnpjRemetente = this.getEmpresa.cnpj ? this.getEmpresa.cnpj : "";

    this.numeroSlide = this.numeroNomeCenario;
    this.addListCenarios(this.id - 1);
    this.nomeCenario = this.id == 1 ? "Cenário 1" : `Cenário ${this.numeroNomeCenario}`;

    this.listaNcmVigente();
    this.setExibeResultado(false);

    window.addEventListener("keydown", this.handleKey);

    this.$bus.$on("buscarResultado", () => {
      this.buscarResultado();
    });
    this.$bus.$on("verificaValidacao", () => {
      this.exibeValidacao = true;
    });
    this.$bus.$on("sobeCenario", () => {
      this.refreshCenario();
    });

    this.refreshCenario();
  },
  async mounted() {
    await new Promise(resolve => {
      const intervalo = setInterval(() => {
        if (!this.loading) {
          clearInterval(intervalo);
          resolve();
        }
      }, 200);
    });
  },

  beforeDestroy() {
    // this.$bus.$off("console");
    this.setDeleteCenario({ id: this.numeroSlide });
    this.$bus.$emit("sobeCenario");
    window.removeEventListener("keydown", this.handleKey);
    this.checaTodosFormularios(this.numeroCenarios, false);
  },

  watch: {
    // OLHA MUDANÇA DE EMPRESA E PEGA CNPJ
    async getEmpresa() {
      this.dadosForm.cnpjRemetente =
        this.getEmpresa && this.getEmpresa.cnpj ? this.getEmpresa.cnpj : "";

      await new Promise(resolve => {
        const intervalo = setInterval(() => {
          if (!this.loading) {
            clearInterval(intervalo);
            resolve();
          }
        }, 200);
      });

      await this.$nextTick(() => {
        if (
          this.dadosForm.tipoOperacao != 41 &&
          this.dadosForm.tipoOperacao != "" &&
          this.getEmpresa.id_uf &&
          this.getEmpresa.id_uf != "0"
        ) {
          this.dadosForm.ufOrigem = this.getEmpresa.id_uf;
        } else if (
          this.dadosForm.tipoOperacao == 41 &&
          this.getEmpresa.id_uf &&
          this.getEmpresa.id_uf != "0"
        ) {
          this.dadosForm.ufDestino = this.getEmpresa.id_uf;
        }
      });
    },
    // OLHA O CENÁRIO INVERTIDO E CARREGA O CENÁRIO DE ACORDO COM A ORDEM E O ID
    getInvertCenariosConfirmed: {
      deep: true,
      async handler() {
        let invertido = {
          ...this.getInvertCenariosConfirmed.find(f => f.idCenario == this.id - 1)
        };
        if (invertido && invertido.idCenario == this.id - 1) {
          await this.$nextTick(async () => {
            this.carregaCenarioLoading = true;
            this.dadosForm.sabeCNPJDestinatario = invertido.sabeCNPJDestinatario
              ? invertido.sabeCNPJDestinatario
              : "0";
            await this.$nextTick(() => {
              this.nomeCenario = invertido.nomeCenario
                ? invertido.nomeCenario
                : `Cenário ${this.numeroNomeCenario}`;
              this.dadosForm.ex = invertido.ex ? invertido.ex : "";
              this.dadosForm.ncm = invertido.ncm ? invertido.ncm : "";
              this.dadosForm.tipoOperacao = invertido.tipoOperacao ? invertido.tipoOperacao : "";
              this.dadosForm.cnaeDestinatario = invertido.cnaeDestinatario
                ? invertido.cnaeDestinatario
                : "";
            });
            await this.$nextTick(() => {
              this.dadosForm.ufOrigem = invertido.ufOrigem ? invertido.ufOrigem : "";
              this.dadosForm.ufDestino = invertido.ufDestino ? invertido.ufDestino : "";
              this.dadosForm.paisOrigem = invertido.paisOrigem ? invertido.paisOrigem : "";
              this.dadosForm.paisDestino = invertido.paisDestino ? invertido.paisDestino : "";
              this.dadosForm.cnaeRemetente = invertido.cnaeRemetente ? invertido.cnaeRemetente : "";
            });
            await this.$nextTick(() => {
              this.dadosForm.atividadeRemetente = invertido.atividadeRemetente
                ? invertido.atividadeRemetente
                : "";
              this.dadosForm.atividadeDestino = invertido.atividadeDestino
                ? invertido.atividadeDestino
                : "";
            });
            await this.$nextTick(() => {
              this.dadosForm.tipoAtividade = invertido.tipoAtividade ? invertido.tipoAtividade : "";
            });
            await this.$nextTick(() => {
              this.dadosForm.regimeDestinatario = invertido.regimeDestinatario
                ? invertido.regimeDestinatario
                : "";
            });
            this.dadosForm.cnpjRemetente = invertido.cnpjRemetente ? invertido.cnpjRemetente : "";
            this.dadosForm.cnpjDestinatario = invertido.cnpjDestinatario
              ? invertido.cnpjDestinatario
              : "";
            this.dadosForm.tipoAtividadeRem = invertido.tipoAtividadeRem
              ? invertido.tipoAtividadeRem
              : "";
            this.dadosForm.origem = invertido.origem ? invertido.origem : "";
            this.dadosForm.destinacao = invertido.destinacao ? invertido.destinacao : "";
            this.dadosForm.zfm = invertido.zfm ? invertido.zfm : "";
            this.dadosForm.regimeRemetente = invertido.regimeRemetente
              ? invertido.regimeRemetente
              : "";
            this.dadosForm.sn_rbt12 = invertido.sn_rbt12 ? invertido.sn_rbt12 : "R$ 0,00";
            this.dadosForm.sn_rba = invertido.sn_rba ? invertido.sn_rba : "R$ 0,00";
            this.dadosForm.sn_rm = invertido.sn_rm ? invertido.sn_rm : "R$ 0,00";
            this.carregaCenarioLoading = false;
          });
        }
      }
    },
    // CHAMA A FUNÇÃO DE SALVAR PASSADA POR PROPS PELO MODAL DE SALVAR
    chamaSalvar() {
      if (this.id == this.cenarioId) {
        this.submitSalvarCenario(true);
      }
    },
    // CHAMA A FUNÇÃO DE LIMPAR PASSADA POR PROPS PELO MODAL DE LIMPAR
    chamaLimpar() {
      if (this.id == this.cenarioId) {
        this.limpaDadosForm();
      }
    },
    // OLHA SE O RESULTADO FOI EXIBIDO E LIBERA OS BOTÕES QUANDO TERMINA
    resultadoExibido() {
      if (!this.resultadoExibido) {
        this.setTrava(false);
      }
    },
    // TRAVA OS BOTÕES ENQUANTO EXISTE LOADING
    loadingResultado() {
      this.setTrava(this.loadingResultado);
    },
    cenarioCnpjRemetente: {
      deep: true,
      handler() {
        this.dadosForm.cnaeRemetente = this.cenarioCnpjRemetente[0].idCnae;

        this.dadosForm.cnpjRemetente = this.cenarioCnpjRemetente.find(f => f.id == this.id)
          ? this.cenarioCnpjRemetente.find(f => f.id == this.id).cnpj
          : "";
      }
    },
    cenarioCnpjDestinatario: {
      deep: true,
      handler() {
        this.dadosForm.cnaeDestinatario = this.cenarioCnpjDestinatario[0].idCnae;

        this.dadosForm.cnpjDestinatario = this.cenarioCnpjDestinatario.find(f => f.id == this.id)
          ? this.cenarioCnpjDestinatario.find(f => f.id == this.id).cnpj
          : "";
      }
    },
    // OLHA A MUDANÇA DE TIPO DE OPERAÇÃO E ALTERA O CAMPO DE UF CONFORME EMPRESA SELECIONADA
    "dadosForm.tipoOperacao": {
      deep: true,
      async handler() {
        await this.$nextTick(() => {
          if (
            this.dadosForm.tipoOperacao != 41 &&
            this.getEmpresa.id_uf &&
            this.getEmpresa.id_uf != "0"
          ) {
            this.dadosForm.ufOrigem = this.getEmpresa.id_uf;
          } else if (
            this.dadosForm.tipoOperacao == 41 &&
            this.getEmpresa.id_uf &&
            this.getEmpresa.id_uf != "0"
          ) {
            this.dadosForm.ufDestino = this.getEmpresa.id_uf;
          }
        });
      }
    },
    // OLHA SE MUDOU O FORMULÁRIO, IGNORA REGRA E ALÍQUOTA DO ICMS, SE HOUVER MUDANÇA SOME COM OS RESULTADOS
    dadosForm: {
      deep: true,
      handler() {
        let dados = { ...this.dadosForm };
        delete dados.regra;
        delete dados.aliquotaIcmsSelecionada;
        if (JSON.stringify(dados) != JSON.stringify(this.cenarioModifica)) {
          this.setExibeResultado(false);
        }
      }
    },
    // INSERE VALOR DE NCM E EX DE ACORDO COM LABEL SELECIONADA
    ncmLabel: {
      deep: true,
      handler() {
        let ncm = this.listaNcm.find(f => f.label == this.ncmLabel);
        this.dadosForm.ex = ncm && ncm.ex != "0" ? ncm.ex : "";
        this.ncm = ncm ? ncm : {};
      }
    },
    // CARREGA O CENÁRIO SALVO QUANDO SELECIONADO NO MODAL E AGUARDA LOADING PARA FAZER ALTERAÇÃO
    getCenario: {
      deep: true,
      async handler() {
        await new Promise(resolve => {
          const intervalo = setInterval(() => {
            if (!this.loading) {
              clearInterval(intervalo);
              resolve();
            }
          }, 200);
        });
        this.carregaCenarioLoading = true;
        if (this.getCenario.idCenario != this.id) return;
        await this.$nextTick(() => {
          this.nomeCenario =
            this.getCenario.nome_cenario && this.getCenario.nome_cenario != "0"
              ? this.getCenario.nome_cenario
              : "";
          this.dadosForm.tipoOperacao =
            this.getCenario.id_local_operacao && this.getCenario.id_local_operacao != "0"
              ? this.getCenario.id_local_operacao
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.sabeCNPJDestinatario =
            this.getCenario.id_local_operacao == 41
              ? "1"
              : this.getCenario.cnae_destinatario != "" && this.getCenario.cnae_destinatario != "0"
              ? "1"
              : "0";
        });
        await this.$nextTick(() => {
          this.dadosForm.cnaeDestinatario =
            this.getCenario.cnae_destinatario && this.getCenario.cnae_destinatario != "0"
              ? this.getCenario.cnae_destinatario
              : "";
          this.dadosForm.cnaeRemetente =
            this.getCenario.cnae_remetente && this.getCenario.cnae_remetente != "0"
              ? this.getCenario.cnae_remetente
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.ufOrigem =
            this.getCenario.id_estado_origem && this.getCenario.id_estado_origem != "0"
              ? this.getCenario.id_estado_origem
              : "";
          this.dadosForm.ufDestino =
            this.getCenario.id_estado_destino && this.getCenario.id_estado_destino != "0"
              ? this.getCenario.id_estado_destino
              : "";
          this.dadosForm.paisOrigem =
            this.getCenario.id_pais_origem && this.getCenario.id_pais_origem != "0"
              ? this.getCenario.id_pais_origem
              : "";
          this.dadosForm.paisDestino =
            this.getCenario.id_pais_destino && this.getCenario.id_pais_destino != "0"
              ? this.getCenario.id_pais_destino
              : "";
          this.dadosForm.cnpjRemetente =
            this.getCenario.cnpj_remetente && this.getCenario.cnpj_remetente != "0"
              ? this.getCenario.cnpj_remetente
              : this.getEmpresa.cnpj
              ? this.getEmpresa.cnpj
              : "";
          this.dadosForm.cnpjDestinatario =
            this.getCenario.cnpj_destinatario && this.getCenario.cnpj_destinatario != "0"
              ? this.getCenario.cnpj_destinatario
              : "";
          this.dadosForm.tipoAtividadeRem =
            this.getCenario.id_remetente_tipo_atividade &&
            this.getCenario.id_remetente_tipo_atividade != "0"
              ? this.getCenario.id_remetente_tipo_atividade
              : "";
          this.dadosForm.zfm = this.getCenario.zfm ? this.getCenario.zfm : "";
          this.carregaCenarioLoading = false;
          this.dadosForm.ncm =
            this.getCenario.ncm && this.getCenario.ncm != ""
              ? this.getCenario.ncm
              : this.dadosForm.ncm;
          this.ncmLabel =
            this.getCenario.ncmLabel && this.getCenario.ncmLabel != ""
              ? this.getCenario.ncmLabel
              : this.ncmLabel;
          // this.dadosForm.ex =
          //   this.getCenario.ex && this.getCenario.ex != "0" ? this.getCenario.ex : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.atividadeRemetente =
            this.getCenario.id_remetente_atividade && this.getCenario.id_remetente_atividade != "0"
              ? this.getCenario.id_remetente_atividade
              : "";
          this.dadosForm.atividadeDestino =
            this.getCenario.id_destinatario_atividade &&
            this.getCenario.id_destinatario_atividade != "0"
              ? this.getCenario.id_destinatario_atividade
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.tipoAtividade =
            this.getCenario.id_destinatario_tipo_atividade &&
            this.getCenario.id_destinatario_tipo_atividade != "0"
              ? this.getCenario.id_destinatario_tipo_atividade
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.regimeDestinatario =
            this.getCenario.id_destinatario_regime && this.getCenario.id_destinatario_regime != "0"
              ? this.getCenario.id_destinatario_regime
              : "";
          this.dadosForm.regimeRemetente =
            this.getCenario.id_remetente_regime && this.getCenario.id_remetente_regime != "0"
              ? this.getCenario.id_remetente_regime
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.origem =
            this.dadosForm.tipoOperacao == 41
              ? "58"
              : this.getCenario.id_origem && this.getCenario.id_origem != "0"
              ? this.getCenario.id_origem
              : "";
          this.dadosForm.destinacao =
            this.getCenario.id_destinacao && this.getCenario.id_destinacao != "0"
              ? this.getCenario.id_destinacao
              : "";
        });
        await this.$nextTick(() => {
          this.dadosForm.sn_rbt12 = this.getCenario.sn_rbt12 ? this.getCenario.sn_rbt12 : "R$ 0,00";
          this.dadosForm.sn_rba = this.getCenario.sn_rba ? this.getCenario.sn_rba : "R$ 0,00";
          this.dadosForm.sn_rm = this.getCenario.sn_rm ? this.getCenario.sn_rm : "R$ 0,00";
        });
      }
    }
  },

  computed: {
    ...mapGetters("listaNcm", {
      arNcmSelecionados: "getArNcmSelecionados",
      ncmsOptions: "getNcmsOptions"
    }),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
    ...mapGetters("empresa", ["getEmpresa"]),
    ...mapGetters("resultado", ["getPossiveisAbasUnidas", "getPossiveisAbasTodas"]),
    ...mapGetters("cenario", [
      "getCenario",
      "getCenarios",
      "getInvertCenariosConfirmed",
      "getDeleteCenario"
    ]),
    ...mapGetters("modal", {
      blShow: "getModalListaCenarios"
    }),
    // VERIFICA QUAIS CAMPOS SÃO REQUERIDOS E RETIRNA UM OBJETO COM OS CAMPOS QUE DEVERIAM SER SELECIONADOS
    camposRequeridos() {
      let requerido = {
        nomeCenario: this.nomeCenario == "" ? true : false,
        ncm: this.dadosForm.ncm == "" ? true : false,
        tipoOperacao: this.dadosForm.tipoOperacao == "" ? true : false,
        ufOrigem:
          this.dadosForm.ufOrigem == "" && ["39", "40", "46"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        ufDestino:
          this.dadosForm.ufDestino == "" && ["40", "41"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        paisOrigem:
          this.dadosForm.paisOrigem == "" && ["41"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        paisDestino:
          this.dadosForm.paisDestino == "" && ["46"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        zfm:
          this.dadosForm.zfm == "" &&
          (["1", "3", "4", "21", "22"].includes(this.dadosForm.ufOrigem) ||
            ["1", "3", "4", "21", "22"].includes(this.dadosForm.ufDestino))
            ? true
            : false,
        atividadeRemetente:
          this.dadosForm.atividadeRemetente == "" &&
          ["", "39", "40", "46"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        cnaeRemetente:
          this.dadosForm.cnaeRemetente == "" &&
          ["", "39", "40", "46"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        regimeRemetente:
          this.dadosForm.regimeRemetente == "" &&
          ["", "39", "40", "46"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        cnaeDestinatario:
          this.dadosForm.cnaeDestinatario == "" &&
          (this.dadosForm.sabeCNPJDestinatario == "1" ||
            ["41"].includes(this.dadosForm.tipoOperacao))
            ? true
            : false,
        atividadeDestino:
          ["", "39", "40", "41"].includes(this.dadosForm.tipoOperacao) &&
          this.dadosForm.atividadeDestino == ""
            ? true
            : false,
        tipoAtividade:
          this.dadosForm.tipoAtividade == "" &&
          ["50", "51"].includes(this.dadosForm.atividadeDestino) &&
          ["", "39", "40", "41"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        regimeDestinatario:
          ["", "39", "40", "41"].includes(this.dadosForm.tipoOperacao) &&
          this.dadosForm.tipoAtividade != "56" &&
          this.dadosForm.regimeDestinatario == ""
            ? true
            : false,
        origem:
          this.dadosForm.origem == "" && ["", "39", "40"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        destinacao:
          this.dadosForm.destinacao == "" &&
          ["", "39", "40", "41"].includes(this.dadosForm.tipoOperacao)
            ? true
            : false,
        // REGRA COMENTADA POIS TEM ERRO NOS CÁLCULOS DO BACK
        // sn_rm:
        //   this.moneyToNumber(this.dadosForm.sn_rba) - this.moneyToNumber(this.dadosForm.sn_rm) >
        //   5760000
        //     ? true
        //     : false,
        //   sn_rba:
        //     this.moneyToNumber(this.dadosForm.sn_rba) - this.moneyToNumber(this.dadosForm.sn_rm) >
        //     5760000
        //       ? true
        //       : false
        // };
        // REGRA PALIATIVA ATÉ ARRUMARES OS PROBLEMAS DO BACK, REMOVER TAMBÉM PARTE COMENTADA NA FUNÇÃO DA CHAMADA DE RESULTADOS

        sn_rba:
          this.moneyToNumber(this.dadosForm.sn_rba) - this.moneyToNumber(this.dadosForm.sn_rm) >
          5760000
            ? true
            : false
      };
      return requerido;
    },
    // RETORNA BOOLEANO QUE INDICA SE HÁ CAMPO REQUERIDO, DIFERENCIANDO BUSCAR RESULTADO OU SALVAR CENÁRIO
    validaCampos() {
      let requerido = { ...this.camposRequeridos };
      if (this.valida == "resultado") {
        delete requerido.nomeCenario;
      } else if (this.valida == "salvar") {
        delete requerido.ncm;
      }
      let requeridoFiltrado = Object.fromEntries(
        Object.entries(requerido).filter(([_, value]) => value == true)
      );
      // console.log(requeridoFiltrado);
      let bool = !Object.keys(requeridoFiltrado).length;
      this.checaTodosFormularios(this.id, bool);
      if (bool) {
        this.exibeValidacao = false;
      }
      return requeridoFiltrado;
    },
    // LIBERA BUSCA DE RESULTADO E APAGA VALIDAÇÃO
    permiteResultado() {
      let bool = !Object.keys(this.validaCampos).length;
      if (bool) {
        this.exibeValidacao = false;
      }
      return bool;
    },
    // FORMATA DADOS PARA ENVIAR NO PAYLOAD DA ROTA DE SALVAR CENÁRIO
    salvarData() {
      let data = {
        ncm: this.dadosForm.ncm ? this.dadosForm.ncm : "",
        tipoOperacao: this.dadosForm.tipoOperacao ? this.dadosForm.tipoOperacao : "",
        ex: this.dadosForm.ex ? this.dadosForm.ex : "",
        cnpjRemetente: this.dadosForm.cnpjRemetente ? this.dadosForm.cnpjRemetente : "",
        cnpjDestinatario: this.dadosForm.cnpjDestinatario ? this.dadosForm.cnpjDestinatario : "",
        ufOrigem: this.dadosForm.ufOrigem ? this.dadosForm.ufOrigem : "",
        ufDestino: this.dadosForm.ufDestino ? this.dadosForm.ufDestino : "",
        paisOrigem: this.dadosForm.paisOrigem ? this.dadosForm.paisOrigem : "",
        paisDestino: this.dadosForm.paisDestino ? this.dadosForm.paisDestino : "",
        atividadeRemetente: this.dadosForm.atividadeRemetente
          ? this.dadosForm.atividadeRemetente
          : "",
        tipoAtividadeRem: this.dadosForm.tipoAtividadeRem ? this.dadosForm.tipoAtividadeRem : "",
        cnaeRemetente: this.dadosForm.cnaeRemetente ? this.dadosForm.cnaeRemetente : "",
        cnaeDestinatario: this.dadosForm.cnaeDestinatario ? this.dadosForm.cnaeDestinatario : "",
        sabeCNPJDestinatario: this.dadosForm.sabeCNPJDestinatario
          ? this.dadosForm.sabeCNPJDestinatario
          : "0",
        atividadeDestino: this.dadosForm.atividadeDestino ? this.dadosForm.atividadeDestino : "",
        tipoAtividade: this.dadosForm.tipoAtividade ? this.dadosForm.tipoAtividade : "",
        origem: this.dadosForm.origem ? this.dadosForm.origem : "",
        destinacao: this.dadosForm.destinacao ? this.dadosForm.destinacao : "",
        zfm: this.dadosForm.zfm ? this.dadosForm.zfm : "0",
        regimeRemetente: this.dadosForm.regimeRemetente ? this.dadosForm.regimeRemetente : "",
        regimeDestinatario: this.dadosForm.regimeDestinatario
          ? this.dadosForm.regimeDestinatario
          : "",
        regra: this.dadosForm.regra ? this.dadosForm.regra : "0",
        sn_rbt12: this.dadosForm.sn_rbt12 ? this.dadosForm.sn_rbt12 : "R$ 0,00",
        sn_rba: this.dadosForm.sn_rba ? this.dadosForm.sn_rba : "R$ 0,00",
        sn_rm: this.dadosForm.sn_rm ? this.dadosForm.sn_rm : "R$ 0,00",
        nomeCenario: this.nomeCenario ? this.nomeCenario : ""
        // idCenario: this.id ? this.id : ""
      };
      return data;
    }
  },

  methods: {
    ...mapActions("empresa", ["setEmpresa"]),
    ...mapActions("modal", ["setModalListaCenarios"]),
    ...mapActions("form", ["setDadosForm"]),
    ...mapActions("alertas", ["fetchAlertas"]),
    ...mapActions("tributosSelecionados", ["setLimpaSelecao"]),
    ...mapActions("cenario", [
      "fetchCenarios",
      "setInvertCenarios",
      "addListCenarios",
      "setDeleteCenario"
    ]),
    ...mapActions("resultado", [
      "setPossiveisAbas",
      "setPossiveisAbasCenario",
      "setLimpaPossiveisAbas"
    ]),
    async gravaLogResultado(dados) {
      let response = await new Api().post("Tools/logResultadoRTE", dados);
      if (response !== undefined) {
        this.idLogCenario = response.id_log_cenario;
      }
    },
    refreshCenario: function() {
      let dados = { ...this.dadosForm };
      dados.idCenario = this.id - 1;
      dados.nomeCenario = this.nomeCenario != "" ? this.nomeCenario : `Cenário ${this.numeroSlide}`;
      this.setInvertCenarios(dados);
    },
    // FUNÇÃO QUE COLOCA FUNÇÕES DE ATALHO DE TECLADO
    handleKey(event) {
      if (this.loading) return;
      if (event.ctrlKey && event.key === "p") {
        event.preventDefault();
        if (this.travaBotoes || !this.resultadoExibido) {
          this.pushAlert(
            "É necessário preencher todos os campos do formulário e aguardar o resultado.",
            "danger"
          );
          // } else if (this.numeroCenarios > 1) {
          //   this.pushAlert("Impressão habilitada apenas para um cenário", "danger");
          //   return;
        } else if (!this.mostraCamposCenario) {
          this.pushAlert(
            "É necessário minimizar a aba de resumo para habilitar a impressão",
            "danger"
          );
          return;
        } else if (this.id == 1) {
          this.$emit("dadosModal", this.id, this.nomeCenario, this.numeroSlide);
          this.imprimirResultado();
        }
      }
      if (event.ctrlKey && event.key === "s" && this.numeroCenarios == 1) {
        event.preventDefault();
        if (this.travaBotoes && this.carregaSalvar) {
          this.pushAlert("Aguarde o salvamento do cenário atual", "danger");
        } else if (this.travaBotoes) {
          this.pushAlert("Aguarde o resultado do cenário atual", "danger");
        } else {
          this.submitSalvarCenario(false);
        }
      }
      if (event.ctrlKey && event.key === "Enter" && this.id == 1) {
        event.preventDefault();
        if (this.travaBotoes) {
          this.pushAlert("Aguarde o resultado do cenário atual", "danger");
        } else if (this.numeroCenarios > 1) {
          this.$emit("resultadoMultiplos");
        } else {
          this.buscarResultado();
          this.$nextTick(() => {
            window.scrollTo(0, document.body.scrollHeight);
          });
        }
      }
      if (this.blShow && (event.key === "ArrowUp" || event.key === "ArrowDown")) {
        event.preventDefault();
      }
      if (event.ctrlKey && event.key === "Backspace" && this.numeroCenarios == 1) {
        event.preventDefault();
        if (this.travaBotoes) {
          this.pushAlert("Aguarde o resultado do cenário atual", "danger");
        } else {
          this.$root.$emit("bv::show::modal", `ModalLimparCenario${this.id}`, "#btnShow");
        }
      }
      if (event.ctrlKey && !event.shiftKey && event.key === " " && this.numeroCenarios == 1) {
        if (this.blUsuarioPro) {
          this.pushAlert("Opção desabilitada na versão de testes", "danger");
          return;
        }

        event.preventDefault();
        this.setModalListaCenarios({ id: this.id, modal: true, ncm: null });
        this.$root.$emit("bv::show::modal", "ModalListaCenarios");
      }
      // if (event.ctrlKey && event.shiftKey && event.key === "Delete" && this.arCenarioSalvo.firstCenario != 1 && this.idCenario > 0) {
      // 	event.preventDefault();
      // 	this.$refs.removerButton.click()
      // }
    },
    // FUNÇÃO QUE TRAVA OS BOTÕES, PASSADA POR PROVIDE
    setTrava(bool) {
      this.travaBotoes = bool;
    },
    // FUNÇÃO QUE COLOCA DADOS NO FORMULÁRIO, PASSADA POR PROPS
    calculaDadosForm(dado, campo) {
      this.dadosForm[campo] = dado;
    },
    // FUNÇÃO QUE COLOCA DADOS NO CENÁRIO, PASSADA POR PROPS
    calculaDados(dado, campo) {
      this[campo] = dado;
    },
    // FUNÇÃO TESTE PARA DEBUGAR
    teste() {
      console.log(this.id);
      console.log(this.numeroNomeCenario);
    },
    // FUNÇÃO QUE BUSCA AS POSSÍVEIS ABAS PARA EXIBIR NO RESULTADO
    buscarPossiveisAbas: async function() {
      try {
        this.dadosForm.tipoOperacao == "46"
          ? (this.dadosForm.regra = 27)
          : this.dadosForm.tipoOperacao == "41"
          ? (this.dadosForm.regra = 1)
          : (this.dadosForm.regra = 0);

        this.setDadosForm({ id: this.id, dadosForm: this.dadosForm });
        const response = await new Api().post("Cenario/obterPossiveisAbas", this.dadosForm);
        if (this.numeroCenarios >= 2) {
          this.setPossiveisAbasCenario([response.dados, this.id]);
          this.setPossiveisAbas(this.getPossiveisAbasUnidas);
        } else {
          this.setPossiveisAbasCenario([response.dados, this.id]);
          this.setPossiveisAbas(response.dados);
        }
      } catch (err) {
        console.error(err);
      }
      this.setExibeCarregando(false);
    },
    // FUNÇÃO QUE BUSCA OS RESULTADOS
    async buscarResultado() {
      if (this.getDeleteCenario.includes(this.numeroSlide)) {
        return;
      }

      this.valida = "resultado";
      this.dadosForm.regra = 0;
      delete this.dadosForm.aliquotaIcmsSelecionada;

      if (!this.permiteResultado) {
        this.exibeValidacao = true;
        console.error(
          Object.keys(
            Object.fromEntries(
              Object.entries(this.camposRequeridos).filter(([_, value]) => value == true)
            )
          )
        );
        if (
          this.moneyToNumber(this.dadosForm.sn_rba) - this.moneyToNumber(this.dadosForm.sn_rm) >
          5760000
        ) {
          this.$nextTick(() => {
            this.pushAlert(
              "Empresa impossibilitada de enquadramento no Simples Nacional. Receita bruta acumulada superior ao limite nacional R$ 5.760.000,00 (R$ 4.800.000,00 + 20%)",
              "danger"
            );
          });
        } else {
          this.$nextTick(() => {
            this.pushAlert("É necessário preencher os campos obrigatórios!", "danger");
          });
        }
        return;
      }
      this.setExibeCarregando(true);
      this.setExibeResultado(true);
      this.setLimpaPossiveisAbas();
      this.cenarioModifica = { ...this.dadosForm };
      delete this.cenarioModifica.regra;
      delete this.cenarioModifica.aliquotaIcmsSelecionada;
      let dataCenario = {
        id: this.id,
        nomeCenario: this.nomeCenario,
        ncmDescricao: this.listaNcm.find(f => f.ncm == this.dadosForm.ncm).descricao,
        termoPesquisado: this.listaNcm.find(f => f.ncm == this.dadosForm.ncm).termo
      };
      this.$emit("dataCenario", dataCenario);

      try {
        //VALIDACAO DE FORMS E EMITE ERROS CASO TENHA
        this.$bus.$emit("abaAtiva", null);

        await this.gravaLogResultado(this.dadosForm);
        await this.buscarPossiveisAbas();

        this.$bus.$emit("abaAtiva", "resultado");
        this.$bus.$emit("limpaBuffer");
        this.setLimpaSelecao();
      } catch (err) {
        console.error(err);
      }
    },
    listaNcmVigente() {
      let ncmSelecionada = this.arNcmSelecionados ? this.arNcmSelecionados : [];
      // let ncmSelecionada = !!this.ncmsOptions.length
      //   ? this.ncmsOptions
      //   : this.arNcmSelecionados
      //   ? this.arNcmSelecionados
      //   : [];
      ncmSelecionada.forEach((p, i) => {
        let label = { label: `${p.ncm} - ${p.descricao.replace("-- ", "").replace("- ", "")}` };
        let valor = { value: p.ncm };
        ncmSelecionada[i] = { ...ncmSelecionada[i], ...label, ...valor };
      });
      let vigente = ncmSelecionada.filter(p => p.vigente == 1);
      let vigenteFiltro = vigente.filter((f, i) => {
        return vigente.findIndex(obj => obj.label === f.label) === i;
      });
      this.listaNcm = vigenteFiltro.sort((a, b) =>
        a.ncm.localeCompare(b.ncm, undefined, { numeric: true })
      );
    },
    // FUNÇÃO QUE LIMPA O FORMULÁRIO
    limpaDadosForm() {
      this.exibeValidacao = false;
      this.dadosForm = {
        ncm: "",
        tipoOperacao: "",
        ex: "",
        cnpjRemetente: "",
        cnpjDestinatario: "",
        ufOrigem: "",
        ufDestino: "",
        paisOrigem: "",
        paisDestino: "",
        atividadeRemetente: "",
        tipoAtividadeRem: "",
        cnaeRemetente: "",
        cnaeDestinatario: "",
        sabeCNPJDestinatario: "0",
        atividadeDestino: "",
        tipoAtividade: "",
        origem: "",
        destinacao: "",
        zfm: "",
        regimeRemetente: "",
        regimeDestinatario: "",
        regra: 0,
        sn_rbt12: "R$ 0,00",
        sn_rba: "R$ 0,00",
        sn_rm: "R$ 0,00"
      };
      this.$nextTick(() => {
        this.limpaKey += 1;
      });
    },
    // FUNÇÃO QUE ABRE O MODAL DE LIMPAR CENÁRIO
    abreModalLimpar() {
      this.$emit("dadosModal", this.id, this.nomeCenario, this.numeroSlide);
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", `ModalLimparCenario${this.id}`, "#btnShow");
      });
    },
    // FUNÇÃO QUE ABRE O MODAL DE REMOVER SEGUNDO OU TERCEIRO CENÁRIO
    abreModalRemover() {
      this.$emit("dadosModal", this.id, this.nomeCenario, this.numeroSlide);
      this.$nextTick(() => {
        this.$root.$emit("bv::show::modal", `ModalRemoverCenario${this.numeroSlide}`, "#btnShow");
      });
    },
    // FUNÇÃO QUE SALVA O CENÁRIO OU ABRE O MODAL DE SOBRESCREVER E FAZ A FUNÇÃO DE SOBRESCRIÇÃO
    async submitSalvarCenario(sobrescreve) {
      if (this.blUsuarioPro) {
        this.pushAlert("Opção desabilitada na versão de testes", "danger");
        return;
      }
      this.valida = "salvar";

      if (!this.permiteResultado && this.dadosForm.nomeCenario != "") {
        this.exibeValidacao = true;
        this.$nextTick(() => {
          this.pushAlert("É necessário preencher os campos obrigatórios!", "danger");
        });
        return;
      }

      let data = this.salvarData;
      let assinatura = localStorage.getItem("assinatura")
        ? JSON.parse(localStorage.getItem("assinatura"))
        : "";

      if (sobrescreve == false) {
        if (this.getCenarios.find(f => f.nome_cenario == data.nomeCenario)) {
          this.$emit("dadosModal", this.id, this.nomeCenario, this.numeroSlide);
          this.$nextTick(() => {
            this.$root.$emit("bv::show::modal", `ModalSalvarCenario${this.id}`, "#btnShow");
          });
          return;
        }
        if (assinatura.qtde_cenario == this.getCenarios.length) {
          this.$nextTick(() => {
            this.pushAlert("Limite de Cenários salvos atingido!", "danger");
          });
          return;
        }
      } else {
        data = {
          ...this.salvarData,
          idCenario: this.getCenarios.find(f => f.nome_cenario == this.salvarData.nomeCenario).id
        };
      }

      this.carregaSalvar = true;
      this.setTrava(true);
      let response = await new Api().post("Cenario/salvarCenarioUsuario", data);

      if (!response.status) {
        this.carregaSalvar = false;
        this.setTrava(false);
        this.pushAlert("Preencha os campos obrigatórios!", "danger");
        return;
      }

      await this.fetchCenarios();
      this.$nextTick(() => {
        this.pushAlert("Cenário Salvo!", "success");
      });
      this.carregaSalvar = false;
      this.setTrava(false);
    },
    // FUNÇÃO QUE EMITE DADOS DO CENÁRIO PARA IMPRESSÃO
    impressaoSeleciona(dados) {
      this.$emit("vSelecaoImpressao", dados);
    },
    // FUNÇÃO QUE ATIVA LOADING, PASSADA POR PROVIDE
    existeLoading(bool) {
      this.loading = bool;
    },
    // FUNÇÃO QUE INDICA ELEMENTO, PASSADA POR PROVIDE
    setElementoCriado(bool) {
      this.elementoCriado = bool;
    },
    handleImprimirResultado() {
      this.$emit("dadosModal", this.id, this.nomeCenario, this.numeroSlide);
      this.imprimirResultado();
    }
  }
};
</script>

<style lang="scss">
.cenario-wrapper {
  margin: 0 1rem 0rem 1rem;
  position: relative;
  // box-shadow: 2px 2px 14px #00000010;
  border-radius: 10px;
}
.cenario-impressao {
  display: none;
}
.bloco-divisao {
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  gap: 10px 100px;
}
.bloco-multiplo {
  grid-template-columns: 1fr;
}

@media only print {
  .cenario-impressao {
    display: block !important;
  }
}
</style>
